import { RiskMapDetailed } from '@models/riskMap'
import { CompanyOption } from '@models/company'
import { DivisionOption } from '@models/division'
import { FilialOption } from '@models/filial'
import { PositionOption } from '@models/position'
import { formatServerDate } from '@utils/date'
import { getPossibilityLabel, getSeverityLabel } from '@utils/riskMaps'
import setDefaultRiskCommissionMembers from '@templates/RiskMemberMultilineFields/setDefaultRiskCommissionMembers'
import INJURY_POSSIBILITIES from '@const/injuryPossibilities'
import SEVERITY_DEGREES from '@const/severityDegrees'
import { dangersControlMeasureWorkplaceOptions } from '@const/dangersControlMeasureWorkplaceOptions'

import { MereFormItem } from '@modals/RiskMapModal/Dangers/DangersFields/DangersFieldsBlock/DangersFieldsMeresModalButton/MeresFields'
import { ProtectionMeanItem } from '@modals/RiskMapModal/Dangers/DangersFields/DangersFieldsBlock/DangersFieldsProtectionMeansModalButton/ProtectionMeansFields'
import { DangerDTOInForm, FormValues } from './index'

export const DEFAULT_HARD_AND_PROBABILITY = {
  hardGrade: SEVERITY_DEGREES[2],
  probability: INJURY_POSSIBILITIES[1],
}

export const DEFAULT_OPTIONS: DangerDTOInForm = {
  meres: [{} as MereFormItem],
  protectionMeans: [{} as ProtectionMeanItem],
  notAutoAddControlMeasures: false,
  notAutoAddProtectionMeans: false,
}

const getDefaultValues = (
  riskMap?: Partial<RiskMapDetailed>
  // eslint-disable-next-line sonarjs/cognitive-complexity
): Partial<FormValues> | void => {
  let result: Partial<FormValues> = {
    dangerDTOs: [DEFAULT_OPTIONS],
    autoAddProtectionMeans: true,
    dangersControlMeasureWorkplace: dangersControlMeasureWorkplaceOptions[0],
  }

  if (!riskMap) return result

  result = {
    number: riskMap.number,
    file: riskMap.file,
    autoAddProtectionMeans: riskMap.autoAddProtectionMeans,
    //   dangers: {
    //     meres: {
    //       mereKind?: Option
    //       content?: Option
    //       source?: string
    //       deadline?: string
    //       responsible?: Option
    //     }[]
    //     type?: Option
    //     kind?: Option
    //     danger?: Option
    //     workPlace?: Option
    //     object?: Option
    //     hardGrade?: Option
    //     probability?: Option
    //   }[]
  }

  const dangersControlMeasureWorkplaceValue =
    dangersControlMeasureWorkplaceOptions.find(
      (item) => item.value === riskMap.dangersControlMeasureWorkplace
    )

  result.dangersControlMeasureWorkplace = dangersControlMeasureWorkplaceValue

  if (riskMap.dangers) {
    result.dangerDTOs = riskMap.dangers.map(
      ({
        event,
        injuryPossibility,
        injurySeverity,
        kind,
        object,
        workPlace,
        hazard,
        notAutoAddControlMeasures,
        notAutoAddProtectionMeans,
      }) => {
        return {
          workPlace: workPlace
            ? {
                label: workPlace.value,
                value: workPlace['@id'],
              }
            : undefined,
          kind: kind
            ? {
                label: kind.value,
                value: kind['@id'],
              }
            : undefined,
          event: event
            ? {
                label: event.value,
                value: event['@id'],
              }
            : undefined,
          hazard: hazard
            ? {
                label: hazard.value,
                value: hazard['@id'],
              }
            : undefined,
          object: object
            ? {
                label: object.value,
                value: object['@id'],
              }
            : undefined,
          hardGrade: injurySeverity
            ? {
                label: getSeverityLabel(injurySeverity),
                value: injurySeverity,
              }
            : undefined,
          probability: injuryPossibility
            ? {
                label: getPossibilityLabel(injuryPossibility),
                value: injuryPossibility,
              }
            : undefined,
          notAutoAddControlMeasures,
          notAutoAddProtectionMeans,
        }
      }
    )
  }

  if (riskMap.reviseBeforeAt) {
    result.reviseBeforeAt = formatServerDate(riskMap.reviseBeforeAt)
  }

  if (riskMap.approvedAt) {
    result.approvedAt = formatServerDate(riskMap.approvedAt)
  }

  if (riskMap.jobPosition) {
    const position = riskMap.jobPosition
    const division = position.subdivision
    const filial = division.companyBranch
    const company = filial.company

    result.company = {
      ...company,
      value: company['@id'],
      label: company.title,
    } as CompanyOption
    result.filial = {
      ...filial,
      value: filial['@id'],
      label: filial.title,
    } as FilialOption
    result.division = {
      ...division,
      value: division['@id'],
      label: division.title,
    } as unknown as DivisionOption
    result.position = {
      ...position,
      value: position['@id'],
      label: position.title,
    } as unknown as PositionOption
  }

  if (riskMap.commissionMembers) {
    return setDefaultRiskCommissionMembers(result, riskMap.commissionMembers)
  }

  return result
}

export default getDefaultValues
